var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 3.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-1 -3.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,12.2H20.063v3.1H3ZM3,9.1H20.063V6H3ZM3,21.512H13.858v-3.1H3Zm23.283-4.855,1.1-1.1a1.545,1.545,0,0,1,2.187,0l1.1,1.1a1.545,1.545,0,0,1,0,2.187l-1.1,1.1Zm-1.1,1.1L16.96,25.979v3.288h3.288l8.221-8.221Z",
    transform: "translate(-3 -6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.9074780e86b022288a0f58749326d57d.svg";
export { ForwardRef as ReactComponent };